import {Status} from '@wix/ambassador-table-reservations-v1-reservation/types'
import {dataHooks} from '@wix/data-hooks'

import {LayoutBreakpointsConfig} from '../../../components-shared/LayoutSizeProvider/types'

export const ALLOWED_STATUSES = [
  Status.RESERVED,
  Status.CANCELED,
  Status.REQUESTED,
  Status.DECLINED,
] as const

export const LAYOUT_BREAKPOINTS_START: LayoutBreakpointsConfig = {
  XS: 280,
  S: 410,
  M: 681,
  L: 1201,
}

export const STATUS_TO_KEYS_MAP: Record<
  (typeof ALLOWED_STATUSES)[number],
  {title: string; subtitle: string; cta: string; details: string}
> = {
  [Status.RESERVED]: {
    title: 'uou-reservations.reservation-confirmation.title',
    subtitle: 'uou-reservations.reservation-confirmation.subtitle',
    cta: 'uou-reservations.reservation-confirmation.cancel-reservation-cta',
    details: 'uou-reservations.reservation-confirmation.reservation-details',
  },
  [Status.CANCELED]: {
    title: 'uou-reservations.reservation-confirmation.cancelled-title',
    subtitle: 'uou-reservations.reservation-confirmation.cancelled-subtitle',
    cta: 'uou-reservations.reservation-confirmation.new-reservation-cta',
    details: 'uou-reservations.reservation-confirmation.cancelled-reservation-details',
  },
  [Status.REQUESTED]: {
    title: 'uou-reservations.reservation-confirmation.requested-title',
    subtitle: 'uou-reservations.reservation-confirmation.requested-subtitle',
    cta: 'uou-reservations.reservation-confirmation.cancel-request-cta',
    details: 'uou-reservations.reservation-confirmation.requested-reservation-details',
  },
  [Status.DECLINED]: {
    title: 'uou-reservations.reservation-confirmation.declined-title',
    subtitle: 'uou-reservations.reservation-confirmation.declined-subtitle',
    cta: 'uou-reservations.reservation-confirmation.new-reservation-cta',
    details: 'uou-reservations.reservation-confirmation.declined-reservation-details',
  },
}

/**
 * Variant copy keys used when a cancellation protection policy is active on the reservation.
 * These keys fall back to the base STATUS_TO_KEYS_MAP values until translations are added.
 */
export const STATUS_TO_KEYS_MAP_WITH_CANCELLATION_POLICY: Partial<
  Record<(typeof ALLOWED_STATUSES)[number], {subtitle: string}>
> = {
  [Status.RESERVED]: {
    subtitle: 'uou-reservations.reservation-confirmation.subtitle-card-secured',
  },
  [Status.REQUESTED]: {
    subtitle: 'uou-reservations.reservation-confirmation.requested-subtitle-payment-on-approval',
  },
}

export const reservationConfirmationDataHooks = dataHooks<{
  root: {}
  cancelReservationModalButton: {}
  cancelReservationPhoneInput: {}
  cancelReservationButton: {}
  makeNewReservationButton: {}
  cardGuaranteeSummary: {}
  cardGuaranteePaymentMethod: {}
  cardGuaranteeTotal: {}
}>('reservation-confirmation')

export const STATUS_TO_CTA_BUTTON_DATA_HOOK_MAP: Record<(typeof ALLOWED_STATUSES)[number], string> =
  {
    [Status.RESERVED]: reservationConfirmationDataHooks.cancelReservationModalButton(),
    [Status.REQUESTED]: reservationConfirmationDataHooks.cancelReservationModalButton(),
    [Status.CANCELED]: reservationConfirmationDataHooks.makeNewReservationButton(),
    [Status.DECLINED]: reservationConfirmationDataHooks.makeNewReservationButton(),
  }

export const WIDGET_ID = '6a32f4a9-81c6-45e1-b99c-a3b0c4088ee2'
